KROWN.saveToSessionStorage = () => {
  const el = document.getElementById('cartSpecialInstructions');
  if ( !el ) return;
  sessionStorage.setItem('cartSpecialInstructions', el.value);
}

const cartSpecialInstructionsEl = document.getElementById('cartSpecialInstructions');
if ( cartSpecialInstructionsEl ) {
  cartSpecialInstructionsEl.addEventListener('input', KROWN.saveToSessionStorage);
}

KROWN.loadFromSessionStorage = () => {
  const savedInstructions = sessionStorage.getItem('cartSpecialInstructions');
  const el = document.getElementById('cartSpecialInstructions');
  if ( savedInstructions && el ) {
    el.value = savedInstructions;
  }
}
document.addEventListener('DOMContentLoaded', KROWN.loadFromSessionStorage);
